import { useEffect, useRef, useState } from 'react';

import { TabProps } from 'types/tabs';

const Tabs = ({ tabs, onTabSelect, selectedTab, className }: TabProps) => {
  const [underlineStyle, setUnderlineStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (selectedTab && tabs) {
      const selectedIndex = tabs.findIndex((tab) => tab.id === selectedTab.id);
      const selectedTabElement = tabRefs.current[selectedIndex];

      if (selectedTabElement) {
        const { offsetLeft, offsetWidth } = selectedTabElement;
        setUnderlineStyle({
          left: offsetLeft,
          width: offsetWidth
        });
      }
    }
  }, [selectedTab, tabs]);

  return (
    <div
      className={`relative flex border-b-2 border-grey40 ${className || ''}`}
    >
      {tabs?.map((tab, index) => (
        <div
          ref={(el) => {
            tabRefs.current[index] = el;
          }}
          role="presentation"
          className="flex min-w-30 cursor-pointer flex-col md:min-w-180"
          key={tab.id}
          onClick={() => {
            onTabSelect?.(tab);
          }}
        >
          <div
            className={`flex justify-center gap-2 truncate px-4 py-3.5 text-center text-base font-medium ${
              selectedTab?.id === tab.id ? 'text-primary' : 'text-content'
            }`}
            key={tab.id}
          >
            {tab.label}
            {(tab.count || tab.count === 0) && (
              <div
                className={`rounded-full px-4 py-1 text-sm font-normal text-content ${
                  selectedTab?.id === tab?.id ? 'bg-primary20' : 'bg-grey90'
                }`}
              >
                {tab.count}
              </div>
            )}
          </div>
        </div>
      ))}

      {/* Sliding underline */}
      <div
        className="duration-250 absolute bottom-0 h-1 bg-primary transition-all ease-out"
        style={{
          left: `${underlineStyle.left}px`,
          width: `${underlineStyle.width}px`
        }}
      />
    </div>
  );
};

export default Tabs;
